import { render } from "./TipModal.vue?vue&type=template&id=6599f9d0"
import script from "./TipModal.vue?vue&type=script&lang=js"
export * from "./TipModal.vue?vue&type=script&lang=js"

import "./TipModal.vue?vue&type=style&index=0&id=6599f9d0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__